export default "__VITE_PUBLIC_ASSET__39e5b568__"